// @flow
import { formatProgramList } from '../../../../../../utils/affordable';
import messages from './messages';

type Params = {
  intl: { formatMessage: (Object, ?Object) => string },
  allAffordableTabsApproved: boolean,
  unapprovedAffordablePrograms?: Array<string>,
  transferCertBlocked?: boolean,
  transferCertTooltip?: string,
  moveInCertBlocked?: boolean,
  moveInCertTooltip?: string,
  providerUnknown?: boolean,
};

export const useGateTooltip = ({
  intl,
  allAffordableTabsApproved,
  unapprovedAffordablePrograms = [],
  transferCertBlocked = false,
  transferCertTooltip = '',
  moveInCertBlocked = false,
  moveInCertTooltip = '',
  providerUnknown = false,
}: Params) => {
  // Three gates, one tooltip, each naming its own programs upstream: `transferCertTooltip` from
  // useTransferLeaseCertGate (resident-side), `moveInCertTooltip` from LeaseDataTabForm (the
  // applicant/move-in gate), and the affordable compliance gate formatted here. The `||` chain is
  // the precedence when more than one can name a program: move-in supersedes the tab-surfaced
  // compliance status on the applicant flow (it catches the HUD case that status misses). The
  // compliance generic fallback keeps the copy off a bare "There is an open certification".
  // Branch on the formatted string, not the raw length: formatProgramList drops empty/whitespace
  // names, so a blank entry falls through to the generic copy rather than interpolating nothing.
  const complianceProgramList = formatProgramList(unapprovedAffordablePrograms);
  const complianceGateTooltip = complianceProgramList
    ? intl.formatMessage(messages.certificationsNotApproved, {
        programs: complianceProgramList,
      })
    : intl.formatMessage(messages.certificationsNotApprovedGeneric);
  const certGateTooltip =
    transferCertTooltip || moveInCertTooltip || complianceGateTooltip;
  const showCertGateTooltip =
    !allAffordableTabsApproved || moveInCertBlocked || transferCertBlocked;
  // An unknown provider is never treated as Fortress: the gated actions stay off and say why.
  const gateTooltip = providerUnknown
    ? intl.formatMessage(messages.providerUnknown)
    : certGateTooltip;
  const showGateTooltip = providerUnknown || showCertGateTooltip;

  return { certGateTooltip, showCertGateTooltip, gateTooltip, showGateTooltip };
};
